import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useNewsletterForm from '../../../../hooks/useNewsletterForm';
import { useAuth } from '../../../../contexts/AuthContext';
import './NewsletterForm.scss';

const NewsletterForm = ({ setNotification, setShowNewsletterModal }) => {
    const { user } = useAuth();
    const {
        values,
        errors,
        isSubmitting,
        submitSuccess,
        submitMessage,
        handleChange,
        handleSubmit
    } = useNewsletterForm({ setNotification, user });

    // Chargement du script reCAPTCHA v3
    useEffect(() => {
        if (!window.grecaptcha) {
            const loadRecaptcha = () => {
                const script = document.createElement('script');
                script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
                script.async = true;
                document.head.appendChild(script);
            };
            loadRecaptcha();
        }
    }, []);


    useEffect(() => {
        if (submitSuccess) {
            setShowNewsletterModal(true);
        }
    }, [submitSuccess])

    if (user?.newsletter) {
        return (
            <div className="newsletter-form__already-subscribed">
                <p>Tu es déjà inscrit(e) à la newsletter.</p>
                <p>Tu peux gérer ton inscription depuis <Link to="/mon-compte">ton espace personnel</Link>.</p>
            </div>
        );
    }

    return (
        <form className="newsletter-form" onSubmit={handleSubmit}>
            <div className="newsletter-form__field">
                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={values.email}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    className={`newsletter-form__input ${errors.email ? 'newsletter-form__input--error' : ''}`}
                />
                {errors.email && (
                    <span className="newsletter-form__error">{errors.email}</span>
                )}
            </div>

            <div className="newsletter-form__field">
                <input
                    type="text"
                    name="prenom"
                    placeholder="Prénom"
                    value={values.prenom}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    className={`newsletter-form__input ${errors.prenom ? 'newsletter-form__input--error' : ''}`}
                />
                {errors.prenom && (
                    <span className="newsletter-form__error">{errors.prenom}</span>
                )}
            </div>

            <div className="newsletter-form__field">
                <input
                    type="text"
                    name="codePostal"
                    placeholder="Code postal"
                    value={values.codePostal}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    className={`newsletter-form__input ${errors.codePostal ? 'newsletter-form__input--error' : ''}`}
                />
                {errors.codePostal && (
                    <span className="newsletter-form__error">{errors.codePostal}</span>
                )}
            </div>

            <button
                type="submit"
                disabled={isSubmitting}
                className="newsletter-form__submit"
            >
                {isSubmitting ? 'INSCRIPTION EN COURS...' : "JE M'INSCRIS"}
            </button>
        </form>
    );
};

export default NewsletterForm;